"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _text = require("@mmc/text");
var _circularChart = _interopRequireDefault(require("./circular-chart"));
var _paymentGraph = _interopRequireDefault(require("./payment-graph.css"));
var PaymentGraph = function PaymentGraph(_ref) {
  var _clsx;
  var className = _ref.className,
    percentage = _ref.percentage,
    imagePath = _ref.imagePath,
    imageAltText = _ref.imageAltText,
    totalLeft = _ref.totalLeft,
    totalLeftLabel = _ref.totalLeftLabel,
    totalRight = _ref.totalRight,
    totalRightLabel = _ref.totalRightLabel,
    summary = _ref.summary,
    leaseSigningDisclaimerNo = _ref.leaseSigningDisclaimerNo,
    dueAtLeaseSigningDisclaimerId = _ref.dueAtLeaseSigningDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    includeTax = _ref.includeTax,
    includesSalesTaxLabel = _ref.includesSalesTaxLabel;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_circularChart["default"], {
    total: percentage
  }), imagePath && /*#__PURE__*/_react["default"].createElement("img", {
    className: _paymentGraph["default"].vehicleImage,
    src: imagePath,
    alt: imageAltText
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _paymentGraph["default"].payments
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _paymentGraph["default"].left
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _paymentGraph["default"].total
  }, totalLeft), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx2["default"])(_paymentGraph["default"].reason, (_clsx = {}, _clsx[_paymentGraph["default"].dueAtLeaseSigningDisclaimerId] = dueAtLeaseSigningDisclaimerId, _clsx))
  }, totalLeftLabel, leaseSigningDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, leaseSigningDisclaimerNo), dueAtLeaseSigningDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: "#" + dueAtLeaseSigningDisclaimerId + "#",
    disclaimerData: disclaimerData,
    tag: "span"
  })), includeTax && /*#__PURE__*/_react["default"].createElement("span", {
    className: _paymentGraph["default"].includeSalesTax
  }, includesSalesTaxLabel)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _paymentGraph["default"].right
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _paymentGraph["default"].total
  }, totalRight), /*#__PURE__*/_react["default"].createElement("p", {
    className: _paymentGraph["default"].reason
  }, totalRightLabel))), summary && /*#__PURE__*/_react["default"].createElement("div", {
    className: _paymentGraph["default"].excerpt
  }, /*#__PURE__*/_react["default"].createElement("p", null, summary)));
};
PaymentGraph.displayName = 'PaymentGraph';
var _default = exports["default"] = PaymentGraph;